import styles from './StudentsList.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import DynamicTable from '../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import Action from '../../components/Action/Action';
import ThreeDotMenu from '../../components/ThreeDotMenu/ThreeDotMenu';
import { useNavigate } from 'react-router';

const data = [
  {
    _id: 'gnswkgnseknsg1',
    studentName: 'xtejkew4',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    actionOptions: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg2',
    studentName: 'xteepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    actionOptions: ['Transfer', 'Delete'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg3',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg4',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg5',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg6',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg6',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg6',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg6',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg6',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: [
      'Active',
      'Send Invite',
      'Update Rooms',
      'Update Status',
      'Update Groups',
      'Transfer Student',
      'Create Folder',
    ],
  },
  {
    _id: 'gnswkgnseknsg7',
    studentName: 'Steepen Pont',
    contact: '468973925',
    emailId: 'staff@gmail.com',
    Room: ['3A', '3W', '3S'],
    status: 'Active',
  },
];

function StudentsList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: (
          <LogoWithName
            name="John Jacob"
            onClick={() => navigate('/management/students/profile')}
            style={{ cursor: 'pointer' }}
          />
        ),
        parents: (
          <div>
            <div>Steeve</div>
            <div>Sara</div>
          </div>
        ),
        room: '3A',
        groups: 'Group 1',
        programs: 'Freshers day',
        gender: 'Male',
        status: <Dropdown label="Active" options={['Active', 'Inactive']} />,
        allergy: '-',
        action: (
          <Action
            key={item._id}
            options={['Transfer', 'Delete']}
            onSelect={(opt) => {
              if (opt === 'Transfer') {
                dispatch(openModal('TransferStudent'));
              } else if (opt === 'Delete') {
                dispatch(openModal('delete'));
              }
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: 'Send Invite',
      onlick: () => {
        console.log('sendInvite');
      },
    },
    {
      label: 'Update Rooms',
      onClick: () => {
        dispatch(openModal('updateRoom'));
      },
    },
    {
      label: 'Update Status',
      onClick: () => {
        dispatch(openModal('statusUpdate'));
      },
    },
    {
      label: 'Update Groups',
      onClick: () => {
        dispatch(openModal('updateGroups'));
      },
    },
    {
      label: 'Transfer Student',
      onClick: () => {
        dispatch(openModal('TransferStudent'));
      },
    },
    {
      label: 'Create Folder',
      onClick: () => {
        dispatch(openModal('createFolder'));
      },
    },
  ];

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Student Name', accessor: 'studentName' },
    { title: 'Parents', accessor: 'parents' },
    { title: 'Room', accessor: 'room' },
    { title: 'Groups', accessor: 'groups' },
    { title: 'Programs', accessor: 'programs' },
    { title: 'Gender', accessor: 'gender' },
    { title: 'Status', accessor: 'status' },
    { title: 'Allergy', accessor: 'allergy' },
    { title: 'Action', accessor: 'action' },
  ];

  return (
    <div className={styles.headerContainer}>
      {/* Status boxes */}
      <div className={styles.resultandcount}>
        <ResultAndCount
          label="Active"
          count={10}
          bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Inactive"
          count={2}
          bgColor="rgba(from var(--Primary_Color) r g b / 0.2)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Pending"
          count={5}
          bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Withdrawn"
          count={1}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.4)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Transferred"
          count={3}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.2)"
          textColor="Black_Color"
        />
      </div>

      {/* Search and Filters */}
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <Dropdown
              label="Room"
              options={['Room1', 'Room2']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Group"
              options={['Group 1', 'Group 2']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Program"
              options={['Annual Day', 'Freshers']}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <ThreeDotMenu options={ActionsData} />
            <IoMdTrash
              size={26}
              style={{
                marginTop: '0.5rem',

                opacity: 0.4,
                color: 'var(--Black_Color)',
                cursor: 'pointer',
              }}
              onClick={() => {
                dispatch(openModal('delete'));
              }}
            />
          </div>
        </div>

        {/* Student Data Table */}
        <div className={styles.dynamicdata}>
          <DynamicTable
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default StudentsList;
